import { el, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import './index.scss';

import positionControlIconString from 'assets/images/position-control-icon.svg?raw';
import moveBackwardIconString from 'assets/images/move-backward-icon.svg?raw';
import moveForwardIconString from 'assets/images/move-forward-icon.svg?raw';
import moveToBackIconString from 'assets/images/move-to-back-icon.svg?raw';
import moveToFrontIconString from 'assets/images/move-to-front-icon.svg?raw';

const moveToFrontIcon = stringToSVG(moveToFrontIconString);
const moveToBackIcon = stringToSVG(moveToBackIconString);
const moveForwardIcon = stringToSVG(moveForwardIconString);
const moveBackwardIcon = stringToSVG(moveBackwardIconString);
const positionControlIcon = stringToSVG(positionControlIconString);

class PositionControlPanel {

  constructor(configuration) {

    this.onMoveForward = configuration.onMoveForward;
    this.onMoveBackward = configuration.onMoveBackward;
    this.onMoveToFront = configuration.onMoveToFront;
    this.onMoveToBack = configuration.onMoveToBack;

    this.controls = this.renderControls();
    this.button = this.renderButton();

    this.el = el('.position-control-panel-main', {
      onmouseenter: this.handleMouseEnter.bind(this),
      onmouseleave: this.handleMouseLeave.bind(this)
    }, [
      this.button
    ]);

  }

  handleMouseEnter() {

    mount(this.el, this.controls);

    const element = this.controls;
    const anchorElement = this.button;
    const viewportElement = void 0;
    const verticalOffset = 0;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top', 'bottom'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  handleMouseLeave() {

    unmount(this.el, this.controls);

  }

  renderControls() {

    const controlButtons = [];

    controlButtons.push(el('x-tooltip', { text: 'Move to top layer' }, el('button.position-control-panel-control', {
      onclick: this.onMoveToFront
    }, moveToFrontIcon)));

    controlButtons.push(el('x-tooltip', { text: 'Move one layer above' }, el('button.position-control-panel-control', {
      onclick: this.onMoveForward
    }, moveForwardIcon)));

    controlButtons.push(el('x-tooltip', { text: 'Move one layer below' }, el('button.position-control-panel-control', {
      onclick: this.onMoveBackward
    }, moveBackwardIcon)));

    controlButtons.push(el('x-tooltip', { text: 'Move to bottom layer' }, el('button.position-control-panel-control', {
      onclick: this.onMoveToBack
    }, moveToBackIcon)));

    return el('.position-control-panel-controls', controlButtons);

  }

  renderButton() {

    return el('button.position-control-panel-control', {}, positionControlIcon);

  }

}

export default PositionControlPanel;